<template>
  <ModuleContainer>
    <slot />
  </ModuleContainer>
</template>

<script>
import L from "@/plugins/leaflet";
import ModuleMixin from "@/components/Map/ModuleMixin";

export default {
  mixins: [ModuleMixin],

  methods: {
    onInit() {
      // Use this.map to access leaflet map
      this.addControl(L.control.zoom());
    },

    onDestroy() {}
  }
};
</script>
